import { render } from "./SvgChannelPorts.vue?vue&type=template&id=e602a462&ts=true"
import script from "./SvgChannelPorts.vue?vue&type=script&lang=ts"
export * from "./SvgChannelPorts.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/tumeda/flui3dbeta/flui3d-mold/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__